import { ContentAlignment, ValueType } from '../models';

/**
 * Determines which content alignment to use based on Magnetic guidelines:
 * https://magnetic.cisco.com/0a43ab5cd/p/313a90-table/t/4269c7
 * @param valueType type of data value
 * @returns content alignment to use
 */
export const getContentAlignment = (valueType: ValueType): ContentAlignment => {
  switch (valueType) {
    case ValueType.NUMBER:
    case ValueType.LONG:
    case ValueType.DOUBLE:
    case ValueType.DURATION:
      return ContentAlignment.RIGHT; // numerical data that could potentially need to be compared
    default:
      return ContentAlignment.LEFT;
  }
};
